// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TableController from "./table_controller.js"
application.register("table", TableController)

import SelectController from "./select_controller"
application.register("select2", SelectController)

import DateTimePickerController from "./datetimepicker_controller.js"
application.register("datetime_picker", DateTimePickerController)
